import script from "./SelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBox.vue?vue&type=script&setup=true&lang=js"

import "./SelectBox.vue?vue&type=style&index=0&id=ccccc250&lang=css"

const __exports__ = script;

export default __exports__